import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from "@heroicons/react/24/solid";
import { Spinner } from "../../../utils/Spinner";

interface MultiPetPickerProps {
    pickerLabel: string;
    activePetName: string;
    petToNodeMapping: Record<string, string>;
    onSelectionChange: (petName: string) => void;
    tabsDisabled?: boolean;
}

export const MultiPetPicker: React.FC<MultiPetPickerProps> = ({
    pickerLabel,
    activePetName,
    petToNodeMapping,
    onSelectionChange,
    tabsDisabled = false
}) => {
    const petNames = Object.keys(petToNodeMapping);
    
    // Go to previous pet
    const goToPreviousPet = () => {
        if (tabsDisabled || petNames.length <= 1) return;

        const currentIndex = petNames.findIndex(name => name === activePetName);
        if (currentIndex > 0) {
            // Go to previous pet
            onSelectionChange(petNames[currentIndex - 1]);
        } else {
            // Wrap around to the last pet
            onSelectionChange(petNames[petNames.length - 1]);
        }
    };

    // Go to next pet
    const goToNextPet = () => {
        if (tabsDisabled || petNames.length <= 1) return;

        const currentIndex = petNames.findIndex(name => name === activePetName);
        if (currentIndex < petNames.length - 1) {
            // Go to next pet
            onSelectionChange(petNames[currentIndex + 1]);
        } else {
            // Wrap around to the first pet
            onSelectionChange(petNames[0]);
        }
    };
    
    return (
        <div className="flex flex-col w-full">
            <label className="text-sm text-gray-500 mb-1">
                {pickerLabel}
            </label>
            <div className="flex flex-row items-center gap-x-2">
                <div
                    onClick={goToPreviousPet}
                    className={`cursor-pointer ${tabsDisabled || petNames.length <= 1 ? "opacity-50" : ""}`}>
                    <ArrowLeftCircleIcon className="h-6 w-6 text-blue-600 hover:text-blue-500 transition-colors" />
                </div>
                <div className="relative w-full">
                    <select
                        className="block w-full rounded-md border-gray-300 focus:border-main-lighter focus:ring-main-lighter"
                        value={activePetName}
                        onChange={(e) => onSelectionChange(e.target.value)}
                        disabled={tabsDisabled}
                    >
                        {petNames.map((petName) => (
                            <option key={petName} value={petName}>
                                {petName}
                            </option>
                        ))}
                    </select>
                    {tabsDisabled && (
                        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70">
                            <Spinner size="h-4 w-4" timer={false} />
                        </div>
                    )}
                </div>
                <div
                    onClick={goToNextPet}
                    className={`cursor-pointer ${tabsDisabled || petNames.length <= 1 ? "opacity-50" : ""}`}>
                    <ArrowRightCircleIcon className="h-6 w-6 text-blue-600 hover:text-blue-500 transition-colors" />
                </div>
            </div>
        </div>
    );
}; 